// src/layouts/Root.jsx
import React from "react";
import TopNavLayout from "../components/Sidebar";
import SubscriptionGate from "../components/SubscriptionGate";
import GlobalTaskCreator from "../components/common/GlobalTaskCreator";
import GlobalDialer from "../components/common/GlobalDialer";
import GlobalDuplicateContact from "../components/common/GlobalDuplicateContact";

const Root = ({ children }) => (
  <TopNavLayout>
    <SubscriptionGate>{children}</SubscriptionGate>
    <GlobalTaskCreator />
    <GlobalDialer />
    <GlobalDuplicateContact />
  </TopNavLayout>
);

export default Root;
